import type { PostHogErrorBoundaryFallbackProps } from 'posthog-js/react'

const shouldShowDetails = import.meta.env.DEV

export function ErrorFallback({ error, componentStack }: PostHogErrorBoundaryFallbackProps) {
  const errorMessage = error instanceof Error ? error.message : String(error)

  return (
    <main className="error-fallback" role="alert">
      <div className="error-fallback__card">
        <p className="error-fallback__eyebrow">Something went wrong</p>
        <h1 className="error-fallback__title">We hit an unexpected issue.</h1>
        <p className="error-fallback__message">
          Try reloading the page. If this keeps happening, let the team know.
        </p>
        <button
          type="button"
          className="error-fallback__button"
          onClick={() => window.location.reload()}
        >
          Reload page
        </button>
        {shouldShowDetails ? (
          <div className="error-fallback__details">
            <p className="error-fallback__detail-title">Error details</p>
            <pre className="error-fallback__detail-block">{errorMessage}</pre>
            {componentStack ? (
              <pre className="error-fallback__detail-block">{componentStack}</pre>
            ) : null}
          </div>
        ) : null}
      </div>
    </main>
  )
}
